import {
  CANCEL_ASSIGN_ENTRY,
  CANCEL_NEW_ENTRY,
  GET_SECTIONS,
  SET_APP_METADATA,
  SET_ASSIGN_ENTRY,
  SET_ERROR,
  SET_LOADING,
  SET_MESSAGES,
  SET_NEW_ENTRY,
  SET_RESPONSE_MESSAGES,
  SET_SECTION,
  TOGGLE_MOBILE,
  UNSET_ERROR,
  UNSET_LOADING,
  UNSET_MESSAGES,
} from 'store/actions/types';

let initialState = {
  sections: [''],
  current_section: {
    name: '',
    endpoint: '',
  },
  error: {
    status: false,
    msg: '',
  },
  loading: false,
  year: null,
  last_active_year_change: null,
  last_password_update: null,
  last_report_generation: null,
  last_users_update: null,
  last_database_cleanup: null,
  new_entry_flag: false,
  assign_entry_flag: false,
  mobile_flag: false,
  messages_flag: true,
  response_messages: [''],
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case UNSET_LOADING:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR:
      return {
        ...state,
        error: {
          status: true,
          msg: action.payload,
        },
      };
    case UNSET_ERROR:
      return {
        ...state,
        error: {
          status: false,
          msg: '',
        },
      };
    case SET_SECTION:
      return {
        ...state,
        current_section: action.payload,
      };
    case GET_SECTIONS:
      return {
        ...state,
        sections: action.payload.data,
      };
    case SET_NEW_ENTRY:
      return {
        ...state,
        new_entry_flag: true,
      };
    case CANCEL_NEW_ENTRY:
      return {
        ...state,
        new_entry_flag: false,
      };
    case SET_ASSIGN_ENTRY:
      return {
        ...state,
        assign_entry_flag: true,
      };
    case CANCEL_ASSIGN_ENTRY:
      return {
        ...state,
        assign_entry_flag: false,
      };
    case TOGGLE_MOBILE:
      return {
        ...state,
        mobile_flag: !state.mobile_flag,
      };
    case SET_MESSAGES:
      return {
        ...state,
        messages_flag: true,
      };
    case UNSET_MESSAGES:
      return {
        ...state,
        messages_flag: false,
      };
    case SET_APP_METADATA:
      return {
        ...state,
        year: action.payload.active_year?.value ?? null,
        last_active_year_change:
          action.payload.last_active_year_change?.created_at ?? null,
        last_password_update:
          action.payload.last_password_update?.created_at ?? null,
        last_report_generation:
          action.payload.last_report_generation?.created_at ?? null,
        last_users_update: action.payload.last_users_update?.created_at ?? null,
        last_database_cleanup:
          action.payload.last_database_cleanup?.created_at ?? null,
      };
    case SET_RESPONSE_MESSAGES:
      return {
        ...state,
        response_messages: action.payload.data,
      };
    default:
      return state;
  }
};

export default appReducer;
